/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * Reducer for widget Personal Account
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.0.1
 */

import produce from 'immer';
import { Reducer } from 'redux';

import {
    WIDGET_PERSONAL_ACCOUNT_LOAD_DATA,
    WIDGET_PERSONAL_ACCOUNT_LOAD_DATA_ERROR,
    WIDGET_PERSONAL_ACCOUNT_LOAD_DATA_SUCCESSFUL,
} from './constants/widgetPersonalAccountActionConstants';
import { widgetPersonalAccountInitialState } from './constants/widgetPersonalAccountConstants';
import { IWidgetPersonalAccountReducer } from './types/widgetPersonalAccountType';
import { TWidgetPersonalAccountAction } from './widgetPersonalAccountActions';

const widgetPersonalAccountReducer: Reducer<IWidgetPersonalAccountReducer, TWidgetPersonalAccountAction> =
    (state = widgetPersonalAccountInitialState, action: TWidgetPersonalAccountAction) =>
        produce(state, draft => {
            switch (action.type) {
                case WIDGET_PERSONAL_ACCOUNT_LOAD_DATA:
                    draft.isLoading = true;
                    draft.data = widgetPersonalAccountInitialState.data;
                    draft.error = widgetPersonalAccountInitialState.error;
                    break;
                case WIDGET_PERSONAL_ACCOUNT_LOAD_DATA_SUCCESSFUL:
                    draft.data = action.payload;
                    draft.isLoading = false;
                    break;
                case WIDGET_PERSONAL_ACCOUNT_LOAD_DATA_ERROR:
                    draft.error = action.payload.error;
                    draft.isLoading = false;
                    break;
                default:
                    break;
            }
        });

export default widgetPersonalAccountReducer;
